import { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
  onAuthStateChanged,
  getAuth,
  signOut,
} from "firebase/auth";
import { updateDoc, doc, getDoc, setDoc, query, collection, where, getDocs } from "firebase/firestore";
import { db } from "../Firebase/firebase";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const auth = getAuth();
  const [user, setUser] = useState(null);
  const [userProfile, setUserprofile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ordem , setordem]=useState([])
  
  const [loadingOrders, setLoadingOrders] = useState(true);



  // 🔁 Keep user logged in
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return unsub;
  }, []);

  // 👈 FIX: Load personal data ONLY when user is available
  useEffect(() => {
    const loadProfile = async () => {
      if (!user) return;

      const userRef = doc(db, "users", user.uid);
      const idSnap = await getDoc(userRef);

      if (idSnap.exists()) {
        setUserprofile({ id: idSnap.id, ...idSnap.data() });
      }
    };

    loadProfile();
  }, [user]);

  // 🔐 REGISTER
  const register = async (loginUser) => {
    const { email, password, idCard, telefone } = loginUser;

    const idRef = doc(db, "idCards", idCard);
    const idSnap = await getDoc(idRef);

    if (idSnap.exists()) {
      throw new Error("Este BI já está registrado.");
    }

    const cred = await createUserWithEmailAndPassword(auth, email, password);

    await sendEmailVerification(cred.user);

    await setDoc(doc(db, "users", cred.user.uid), loginUser);

    await setDoc(idRef, {
      uid: cred.user.uid,
      telefone,
    });

    return cred.user;
  };

  // 🔑 LOGIN
  const login = async (email, password) => {
    const cred = await signInWithEmailAndPassword(auth, email, password);

    if (!cred.user.emailVerified) {
      await signOut(auth);
      throw new Error("Abre seu e-mail e clica no link de verificação antes de entrar.");
    }

    return cred.user;
  };

  // ✏️ Update User
  const updateUserProfile = async (uid, data) => {
    const userRef = doc(db, "users", uid);
    await updateDoc(userRef, data);
  };

  //---- consult products ordered-----
//---- consult products ordered-----
useEffect(() => {    
  const pedido = async () => {
    try {
      if (!user?.uid) return; // <-- Isto evita undefined no where()

      const ref = query(
        collection(db, "orders"),
        where("requesterId", "==", user.uid)
      );
        setLoadingOrders(true)
      const snap = await getDocs(ref);

      const result = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

   

      setLoadingOrders(false);
      setordem(result);
  
    } catch (err) {
      console.log("erro na consulta de numero de order pelo usuario " + err);
    }
  };

  pedido();
}, [user?.uid]);  // <-- dependência correta


//--------- looking for pending order and save in memory to be used 
// --------- ORDERS STATE GROUPING ---------
const pendingOrders = useMemo(() => {
  if (!ordem || ordem.length === 0) return [];

  const result = [];

  ordem.forEach(order => {
    const basket = order?.items?.basket ?? [];
    basket.forEach(item => {
      if (item.status === "Pending") {
        result.push({
          orderId: order.id,
          ...item
        });
      }
    });
  });

  return result;
}, [ordem]);


const soldOrders = useMemo(() => {
  if (!ordem || ordem.length === 0) return [];

  const result = [];

  ordem.forEach(order => {
    const basket = order?.items?.basket ?? [];
    basket.forEach(item => {
      if (item.status === "Sold") {
        result.push({
          orderId: order.id,
          ...item
        });
      }
    });
  });

  return result;
}, [ordem]);


// Total numbers
const totalPending = pendingOrders.length;
const totalSold = soldOrders.length;
  



  const totalOrders = useMemo(() => ordem.length, [ordem]);

 




  const logout = () => signOut(auth);

  return (
    <AuthContext.Provider
      value={{
        user,
        userProfile,   // 👈 NOW AVAILABLE HERE
        ordem, // dados de ordem de compras do usuario
      pendingOrders,
    soldOrders,
    totalPending,
    totalSold,
    totalOrders, 
        register,
        login,
        logout,
        updateUserProfile,
        loading,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);